import {layer} from '@wandb/components';
import * as Dialog from '@wandb/weave/components/Dialog';
import React, {memo, useEffect} from 'react';

import {useViewer} from '../../../state/viewer/hooks';
import {UpdatePaymentForm} from '../UpdatePaymentForm';
import {BillingAddressContextProvider} from './BillingAddressContext';

type AddPaymentMethodModalProps = {
  billingUserEmail: string;
  organizationID: string;
  organizationName: string;
  shouldDefault: boolean;
  shouldRetryOpenInvoices: boolean;
  onTransactionCompleted: () => void;
  onClose: () => void;
};

const AddPaymentMethodModalComp = ({
  billingUserEmail,
  organizationID,
  organizationName,
  onTransactionCompleted,
  shouldDefault,
  shouldRetryOpenInvoices,
  onClose,
}: AddPaymentMethodModalProps) => {
  const viewer = useViewer();
  useEffect(() => {
    window.analytics?.track('Add Payment Method Modal Opened', {
      location: 'add payment method modal',
      organizationID,
      organizationName,
      userID: viewer?.id,
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog.Root open onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-black/30 fixed inset-0" />
        <Dialog.Content className="fixed left-1/2 top-1/2 w-[550px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-wb-surface p-40 shadow-lg">
          <div className="mb-24">
            <Dialog.Title className="text-20 font-semibold">
              Add Payment Method
            </Dialog.Title>
          </div>
          <BillingAddressContextProvider>
            <UpdatePaymentForm
              customerEmail={billingUserEmail}
              organizationId={organizationID}
              onUpdateCompleted={onTransactionCompleted}
              shouldDefault={shouldDefault}
              shouldRetryOpenInvoices={shouldRetryOpenInvoices}
              onClose={onClose}
            />
          </BillingAddressContextProvider>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export const AddPaymentMethodModal = memo(AddPaymentMethodModalComp);
